import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusTopRight16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconRadiusTopRight16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 7.363v3a.5.5 0 1 0 1 0v-3a5.5 5.5 0 0 0-5.5-5.5h-3a.5.5 0 0 0 0 1h3a4.5 4.5 0 0 1 4.5 4.5M3.5 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m4.25 5.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m-2.25-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m5.25.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M3.5 10.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusTopRight16);
